<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj pracownika' : 'Dodaj pracownika' }}</v-flex>

    <profile-form :schema="$schema" :simple="true" :edit="!!id" :loginGenerate="false" :hideEmail="true" :show="show" />

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType, SessionStorage } from '@witkac/kartamiejska-shared';
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/employee.schema';
import ProfileForm from '../../profile/ProfileForm';

const emptyData = () => ({
  login: '',
  partnerId: parseInt(localStorage.getItem(SessionStorage.PARTNER_ID), 10),
  profile: {
    firstName: '',
    lastName: '',
    type: ProfileType.PARTNER,
    email: '',
    mainImage: null
  }
});

export default {
  components: { modal, ProfileForm },
  mixins: [manageMixin('employees', {}, emptyData)],
  schema,
  props: {
    id: { type: String, required: false }
  },
  methods: {
    // @vuese
    // pobiera identyfikator pracownika
    getId() {
      return this.stateData.profile.id;
    },

    // @vuese
    // aktualizacja pracownika
    update() {
      this.model.profile.userId = this.id;
      this.$emit('update', {
        id: this.getId(),
        ...this.model
      });
    }
  }
};
</script>
